import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import { indigo } from '@material-ui/core/colors'
import Grid from 'atoms/layout/Grid'
import Typography from 'atoms/display/Typography'
import NoWrap from 'atoms/display/NoWrap'
import Box from 'atoms/layout/Box'
import Container from 'atoms/layout/Container'
import EyeCatchImage from 'images/home_eye_catching.png'

const useStyle = makeStyles(() => createStyles({
  backgroundBox: {
    background: indigo['800']
  },
  heading: {
    color: 'white'
  },
  text: {
    color: 'white'
  },
  image: {
    display: 'block',
    width: '80%',
    margin: 'auto'
  }
}))

export default function Messages () {
  const classes = useStyle()

  return (
    <Box
      className={classes.backgroundBox}
      py={6}
    >
      <Container>
        <Box mb={6}>
          <Typography
            variant="h5"
            fontWeight={700}
            align="center"
            className={classes.heading}
          >
            「生命とは何か？」を科学ダイナミクスから解き明かす。
          </Typography>
        </Box>
        <Grid
          container
          spacing={4}
          alignItems="center"
        >
          <Grid
            item
            xs={12}
            sm={4}
          >
            <img
              src={EyeCatchImage}
              alt="画像"
              className={classes.image}
            />
          </Grid>
          <Grid
            container
            item
            xs={12}
            sm={8}
            spacing={4}
            justify="flex-end"
            alignItems="center"
          >
            <Grid item>
              <Typography className={classes.text}>
                <NoWrap>生命体は、心臓の鼓動や概日性で見られるように「リズム」を刻んだり、</NoWrap>
                <NoWrap>特徴的な「パターン(形や模様)」を形成しながら生命活動を営んでいます。</NoWrap>
              </Typography>
            </Grid>
            <Grid item>
              <Typography className={classes.text}>
                <NoWrap>このようなリズムやパターンを自発的に形成する現象を「自己組織化」といい、</NoWrap>
                <NoWrap>生命現象にとって重要な役割を担っています。</NoWrap>
              </Typography>
            </Grid>
            <Grid item>
              <Typography className={classes.text}>
                <NoWrap>本研究室では、「自己組織化」に関する現象を科学的に解明する研究や、</NoWrap>
                <NoWrap>生物に学ぶモデル実験系を構築する研究を行っています。</NoWrap>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}
